import React from "react";
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import { TextField } from "@material-ui/core";

import '../../../../styles.css';

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;
    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            showMask
        />
    );
}

function TextMaskCustomCel(props) {
    const { inputRef, ...other } = props;
    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            showMask
        />
    );
}

export default function BasicInfo(props) {
    const handleChange = (event) => {
        props.setValues({
            ...props.values,
            [event.target.id]: event.target.value,
        });
        console.log(event.target.id)
    };

    return (
        <>
            <div className="fundo">
                <div className="rowForm">
                    <div className="autoFornecedor">
                        <TextField
                            id="equipamento"
                            margin="dense"
                            label="Equipamento/Recurso"
                            value={props.values.equipamento}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="autoFornecedor">
                        <TextField
                            id="cidade"
                            margin="dense"
                            label="Cidade"
                            value={props.values.cidade}
                            onChange={handleChange}
                        />
                    </div>
                </div>


                <div className="rowForm">
                    <div className="autoFornecedor">
                        <TextField
                            id="responsavel"
                            margin="dense"
                            label="Responsável"
                            value={props.values.responsavel}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="autoFornecedor">
                        <TextField
                            id="local"
                            margin="dense"
                            label="Local"
                            value={props.values.local}
                            onChange={handleChange}
                        />
                    </div>

                </div>

                <div className="rowForm">
                    <div className="autoFornecedor">
                        <TextField
                            margin="dense"
                            id="telefone"
                            label="Telefone"
                            onChange={handleChange}
                            value={props.values.telefone}
                            InputProps={{ inputComponent: TextMaskCustom }}
                        />
                    </div>

                    <div className="autoFornecedor">
                        <TextField
                            margin="dense"
                            id="celular"
                            label="Celular/WhatsApp"
                            onChange={handleChange}
                            value={props.values.celular}
                            InputProps={{ inputComponent: TextMaskCustomCel }}
                        />
                    </div>


                </div>
            </div>
        </>
    )
}

BasicInfo.propTypes = {
    update: PropTypes.bool,
    values: PropTypes.object,
    setValues: PropTypes.func
};
